<template>
  <div>
    <div class="md-display-1" style="margin: 40pt 0;">
      <div style="text-align:center;">
          <img :src="logoSrc" style="max-height:200pt;" />
      </div>
    </div>

    <div class="md-body-2">
      <p>Onderstaand uw klantgegevens.<br /> Voor wijzigingen, <a :href="`mailto:${$infoMail}?subject=Wijzigen klantgegevens&body=Naam: ${item.Naam}%0D%0AKlantnummer: ${loginName}%0D%0A%0D%0AGraag wijzigen:%0D%0A`">klik hier</a> of stuur een e-mail naar {{ $infoMail }}.</p>
    </div>
    <prop-card id="propsCard" :data="item" :header="item != null ? item.Naam : ''"></prop-card>
  </div>
</template>

<script>
  import Api from '@/api';
  import PC from '@/components/PropCard';
  import { Events } from '@wsb/wsb-jsbase';

/////////////////////////
/////////////////////////////////////////////////////
//////////////////////////
//////////////////////////////////////////////////////
//////////////////////////
  var logoSrc = require('@/assets/alli/FullLogo.png');
/////////////////////////
/////////////////////////////////////////////////////
////////////

  const _home = {
    name: 'Start',
    data() {
      return {
        item: null,
        logoSrc: logoSrc,
        loginName: null
      };
    },
    created() {
      Api.Get('/odata/Customer')
        .then(resp => {
          var v = resp.value[0];
          this.item = {
            Naam: v.Name,
            'Nr.': v.No,
            Adres: `${v.Address}\r\n${v.Post_Code}, ${v.City}`,
          };
          if (v.wPostAdres) { this.item.Factuuradres = `${v.wPostAdres}\r\n${v.wPostPostcode}, ${v.wPostPlaats}`; }
          if (v.wShipToAddress) {
            const verz = `${v.wShipToAddress}\r\n${v.wShipToPostCode}, ${v.wShipToCity}`;
            if (verz != this.item.Adres) {
              this.item.Verzendadres = verz;
            }
          }
          if (v.E_Mail) { this.item.Email = v.E_Mail; }
          if (v.Phone_No) { this.item['Tel.'] = v.Phone_No; }
          if (v.wMobilePhoneNo) { this.item['Mob.'] = v.wMobilePhoneNo; }
          this.item["Portal email"] = v.wWebPortalEmail;
        })
        .catch(Events.RaiseExceptionOccurred);

      global.Auth.GetToken()
        .then(tok => {
          this.loginName = tok.sub;
        });
    },
    components: {
      'prop-card': PC
    }
  };

  export default _home;
</script>

<style scoped>
  #propsCard {
    position: absolute;
    min-width: 300pt;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue